import { DefaultOptions, QueryClient } from '@tanstack/react-query'
import { defaultMutationFn } from './react-query'

// export const defaultQueryClient = new QueryClient({
//   defaultOptions: {
//     mutations: {
//       mutationFn: defaultMutationFn
//     },
//     queries: {
//       // fetcher: getManyBaseReactQuery
//       // staleTime: 10 * 1000 // 10 Seconds
//     }
//   }
// })

// ------------------------------------------------ //

export const getDefaultQueryClient = (ctx?) => {
  const defaultMutationOptions: DefaultOptions['mutations'] = {
    mutationFn: defaultMutationFn,
    meta: {}
  }

  const defaultQueryOptions: DefaultOptions['queries'] = {
    // fetcher: getManyBaseReactQuery,
    meta: {},
    // Testing these below features...
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000 // 10 Seconds,
  }

  if (ctx?.req?.headers?.cookie) {
    Object.assign(defaultMutationOptions, { meta: { cookie: ctx?.req?.headers?.cookie } })
    Object.assign(defaultQueryOptions, { meta: { cookie: ctx?.req?.headers?.cookie } })
  }

  return new QueryClient({
    defaultOptions: {
      mutations: defaultMutationOptions,
      queries: defaultQueryOptions
    }
  })
}

export type AutoInvalidationConfig = { mutationKey: string; queryKeys: string[] }[]
